'use client'

import { Text } from '@vinted/web-ui'
import { Suspense } from 'react'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAbTest, useTrackAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

import { AdControls } from './AdControls'

type Props = {
  underline?: boolean
}

const AdInfo = ({ underline }: Props) => {
  const translate = useTranslate('advertisements')

  const adReportTest = useAbTest('ad_report')
  useTrackAbTest(adReportTest)
  const shouldShowAdControls = adReportTest?.variant === 'on'

  return (
    <Suspense>
      <div className="slot-info" data-testid="slot-info" suppressHydrationWarning>
        <div className="slot-info__content">
          <Text
            as="h4"
            type="caption"
            theme="muted"
            text={translate('advertisement')}
            underline={underline}
          />
          {shouldShowAdControls && <AdControls />}
        </div>
      </div>
    </Suspense>
  )
}

export default AdInfo
